import { type Provider } from '@angular/core';
import { provideMediaStudio } from '@mtm/media-studio';

import { environment } from '../../../environments/environment';

/**
 * `@mtm/media-studio`'s base providers (player translate fn, config, pdf worker).
 * Registered both on the lazy drive scopes and at the root: the feed's file
 * preview pop-in is created from the ROOT environment injector, so on org pages
 * (no drive scope) it otherwise dies with NG0201 on `MTM_PLAYER_TRANSLATE_FN`.
 *
 * pdf.workerSrc: self-host the pdfjs worker. The media-studio default points
 * at cdn.jsdelivr.net, which the deployed CSP (`script-src` in
 * devops/angular2/nginx/nginx.conf) blocks — pdfjs then falls back to a
 * main-thread "fake worker" that fetches the same blocked URL and every PDF
 * preview fails. Invisible in local dev, which serves no CSP. The worker is
 * copied from node_modules/pdfjs-dist/build by the `assets` entry in
 * angular.json; the path must stay root-absolute so it resolves the same on
 * every route (pdfjs resolves workerSrc against the current URL).
 */
export function provideMtmMediaStudio(): Provider[] {
  return provideMediaStudio({
    pdf: { workerSrc: '/assets/pdfjs/pdf.worker.min.mjs' },
    apiUrl: environment.drive.apiUrl,
  });
}
